// Section One Animation
document.addEventListener('DOMContentLoaded', function() {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.home-top-section',
        start: 'top 50%', // Triggers when the top of the section hits 50% of the viewport height
        toggleActions: 'play none none none', // Plays once when entering view
        markers: false // Set to true for debugging
      }
    });

    // From right with fade-in (slower) for headings
    tl.from('.main-heading-one', { x: '100%', opacity: 0, duration: 1.5, ease: 'power3.out' }, 0);
    tl.from('.main-heading-two', { x: '100%', opacity: 0, duration: 1.5, ease: 'power3.out' }, 0.3);
    tl.from('.sub-heading', { x: '100%', opacity: 0, duration: 1.5, ease: 'power3.out' }, 0.6);

    // From left with fade-in (slower) - synced to start with headings
    tl.from('.image-item.first', { x: '-100%', opacity: 0, duration: 2, ease: 'power3.out' }, 0.3);

    // From bottom with fade-in (slower) - synced to start with headings
    tl.from('.image-item.second', { y: '100%', opacity: 0, duration: 2, ease: 'power3.out' }, 0.3);

});



//Section two
document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.section-below-home',
      start: 'top 50%', // Triggers when the top of the section hits 80% of the viewport height
      toggleActions: 'play none none none', // Plays once when entering view
      markers: false // Set to true for debugging
    }
  });

  // From left with fade-in (slower)
  tl.from('.title', { x: '-100%', opacity: 0, duration: 1.5, ease: 'power3.out' }, 0);
  tl.from('.des', { x: '-100%', opacity: 0, duration: 1.5, ease: 'power3.out' }, 0.3);

  // From bottom with fade-in (slower)
  tl.from('.img-dots', { y: '100%', opacity: 0, duration: 2, ease: 'power3.out' }, 0.6);

  // From right with fade-in (slower)
  tl.from('.image-blocks.section-two', { x: '100%', opacity: 0, duration: 2, ease: 'power3.out' }, 0.9);
});

//Section three
document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.to('.single-banner img', {
    y: '40%', // Moves image down 20% for parallax depth
    ease: 'none',
    scrollTrigger: {
      trigger: '.single-banner',
      start: 'top bottom', // Starts when section top hits viewport bottom
      end: 'bottom top', // Ends when section bottom hits viewport top
      scrub: true, // Smoothly links to scroll speed
      markers: false // Set to true for debugging
    }
  });
});


//Section Four 
// document.addEventListener('DOMContentLoaded', function() {
//   gsap.registerPlugin(ScrollTrigger);

//   const cards = gsap.utils.toArray('.card-wrap').reverse();
//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: '.big-card-wrap',
//       pin: true,
//       start: 'top top',
//       end: () => '+=' + (cards.length * (window.innerHeight * 0.7)), // Reduced height by 30%
//       scrub: 1,
//       snap: {
//         snapTo: "labels", // Snap to labels for pausing at each card
//         duration: {min: 0.2, max: 2}, // Snap animation duration
//         delay: 0.2, // Delay before snapping
//         ease: "power1.inOut" // Smooth snapping
//       },
//       fastScrollEnd: true, // Forces animation to complete on fast scrolls
//       preventOverlaps: true, // Prevents overlapping triggers
//       markers: false
//     }
//   });

//   // Add labels for snapping points
//   tl.addLabel("start");

//   cards.forEach((card, i) => {
//     tl.to(card, {
//       opacity: 1,
//       y: -i * 50,  // Stacks each card 50px above the previous
//       duration: 1,
//       ease: 'power2.out'
//     });
//     tl.addLabel(`card${i}`); // Label for each card to snap to
//   });

//   tl.addLabel("end");
// });
gsap.registerPlugin(ScrollTrigger);

const cardWraps = gsap.utils.toArray(".big-card-wrap .card-wrap");

cardWraps.forEach((cardWrap, i) => {
  let scale = 1,
      rotation = 0;

  // Similar scaling and rotation logic as your original example
  if (i !== cardWraps.length - 1) {
    scale = 0.9 + 0.025 * i;
    rotation = -10;
  }

  gsap.to(cardWrap, {
    scale: scale,
    rotationX: rotation,
    transformOrigin: "top center",
    ease: "none",
    scrollTrigger: {
      trigger: cardWrap,
      start: "top " + (60 + 10 * i),
      end: "bottom 550",
      endTrigger: ".big-card-wrap",
      scrub: true,
      pin: cardWrap,
      pinSpacing: false,
      // Optionally enable markers for debugging
      // markers: true,
      id: "card-" + (i + 1)
    }
  });
});


//newsletter section 
// document.addEventListener('DOMContentLoaded', function() {
//     gsap.registerPlugin(ScrollTrigger);

//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: '.newsletter',
//         start: 'top 60%', // Triggers when the top of the section hits 80% of the viewport height
//         toggleActions: 'play none none none', // Plays once when entering view
//         markers: false // Set to true for debugging
//       }
//     });

//     // Scale from 0 to 1 with fade-in for news-one
//     tl.from('.news-one', { scale: 0, opacity: 0, duration: 1.5, ease: 'power3.out' }, 0);

//     // From top with fade-in for the heading
//     tl.from('.newsletter-heading.h1', { y: '-100%', opacity: 0, duration: 1.5, ease: 'power3.out' }, 0.3);

//     // From bottom with fade-in for the form
//     tl.from('.newsletter-form', { y: '100%', opacity: 0, duration: 2, ease: 'power3.out' }, 0.6);

//     // Scale from 0 to 1 with fade-in for news-two
//     tl.from('.news-two', { scale: 0, opacity: 0, duration: 1.5, ease: 'power3.out' }, 0.9);
//   });

//   //Menu
//   document.addEventListener('DOMContentLoaded', function () {
//   if (!window.gsap) return;

//   const drawer = document.getElementById('menu-drawer');
//   const navList = drawer?.querySelector('.menu-drawer__menu');
//   const navItems = navList ? navList.querySelectorAll(':scope > li') : [];
//   const infoTab = drawer?.querySelector('.info-tab');
//   const utility = drawer?.querySelector('.menu-drawer__utility-links');

//   // Prep initial states (no flash)
//   gsap.set(drawer,   { xPercent: 100 });          // off-canvas to the right
//   gsap.set(infoTab,  { xPercent: -20, opacity: 0 }); // from left
//   gsap.set(navItems, { xPercent: 30,  opacity: 0 }); // from right
//   gsap.set(utility,  { yPercent: 15,  opacity: 0 }); // slight bottom rise

//   // Build the open timeline (paused, reversible)
//   const tl = gsap.timeline({ paused: true, defaults: { duration: 0.6, ease: 'power3.out' }});

//   tl.to(drawer, { xPercent: 0, duration: 0.5 }, 0) // slide drawer in
//     .to(infoTab, { xPercent: 0, opacity: 1 }, 0.05) // info tab from left
//     .to(navItems, {
//       xPercent: 0,
//       opacity: 1,
//       stagger: { each: 0.08, from: 'start' }
//     }, 0.1) // li items from right, staggered
//     .to(utility, { yPercent: 0, opacity: 1 }, 0.15); // bottom utility links

//   // Example: integrate with your drawer toggle logic
//   // If Dawn toggles body class 'js-drawer-open' or drawer has data-opened, adapt here.
//   const drawerToggleButtons = document.querySelectorAll('[data-drawer-toggle="menu"]');
//   drawerToggleButtons.forEach(btn => {
//     btn.addEventListener('click', () => {
//       const isOpen = drawer.classList.contains('is-open');
//       if (isOpen) {
//         // closing
//         tl.reverse();
//         drawer.classList.remove('is-open');
//         drawer.setAttribute('aria-hidden', 'true');
//       } else {
//         // opening
//         tl.play(0);
//         drawer.classList.add('is-open');
//         drawer.removeAttribute('aria-hidden');
//       }
//     });
//   });

//   // If your theme fires a custom event on open/close, hook into those instead:
//   // document.addEventListener('drawer:open', e => { if (e.detail?.id === 'menu-drawer') tl.play(0); });
//   // document.addEventListener('drawer:close', e => { if (e.detail?.id === 'menu-drawer') tl.reverse(); });
// });

document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.home-top-section', // Adjust trigger selector as needed
      start: 'top 50%',
      toggleActions: 'play none none none',
      markers: false
    }
  });

  // From left for product media wrapper
  tl.from('.product.grid .grid__item.product__media-wrapper', {
    x: '-100%',
    opacity: 0,
    duration: 2,
    ease: 'power3.out'
  }, 0);

  // From right for all direct div children inside sticky info container
  tl.from('.product__info-container.product__column-sticky > div', {
    x: '100%',
    opacity: 0,
    duration: 2,
    ease: 'power3.out'
  }, 0.3);

  // From bottom for accordion headings
  tl.from('.accordion > .heading', {
    y: '100%',
    opacity: 0,
    duration: 2,
    ease: 'power3.out'
  }, 0.3);
});
